'use strict';

var generatedCraftcms = require('@liquorice/generated-craftcms');

const FORMIE_NESTED_ROW_FRAGMENT = generatedCraftcms.gql(`
  fragment formieNestedRow on RowInterface {
    __typename
    id
    rowFields {
      __typename
      id
      handle
      ...fieldBase
      ...fieldAddressCountry
    }
  }
`);

exports.FORMIE_NESTED_ROW_FRAGMENT = FORMIE_NESTED_ROW_FRAGMENT;
